exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disableLevel .el-cascader-menu:nth-child(1) .el-checkbox{display:none}\n", ""]);

// exports
